import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { queriesApi } from "../../app/slices/queriesSlice";
import { createMRTColumnHelper } from "material-react-table";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import CustomTable from "../../components/customTable/CustomTable";
import { Box } from "@mui/material";

export default function WebsiteQueries() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  useEffect(() => {
    dispatch(queriesApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse = useSelector((state) => state.queries.queries.data);
  const stateLoading = useSelector((state) => state.queries.loading);
  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>{cell.row.original?.name}</div>
      ),
    }),
    columnHelper.accessor("mobileNo", {
      header: "Mobile No",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.mobileNo || "N/A"}
        </div>
      ),
    }),
    columnHelper.accessor("email", {
      header: "Email",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>{cell.row.original?.email}</div>
      ),
    }),
    columnHelper.accessor("subject", {
      header: "Subject",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>{cell.row.original?.subject}</div>
      ),
    }),
    columnHelper.accessor("message", {
      header: "Message",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>{cell.row.original?.message}</div>
      ),
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original.updatedAt.split("T")[0]}
        </div>
      ),
    }),
  ];
  return (
    <>
      <DateSearchComponent onSearch={handleSearch} />
      <Box mt={2} >
        <CustomTable
          columns={columns}
          data={sliceResponse}
          loading={stateLoading}
          permissionKey="Queries"
        />
      </Box>
    </>
  );
}
